import React from 'react';

import Responsive from '@/components/Responsive';

import FilterActionsDesktop from './index.desktop';
import FilterActionsMobile from './index.mobile';
import { FilterActionProps } from './types';

function FilterActions(props: FilterActionProps) {
  return (
    <Responsive>
      <Responsive.Default>
        <FilterActionsDesktop {...props} />
      </Responsive.Default>
      <Responsive.Mobile>
        <FilterActionsMobile {...props} />
      </Responsive.Mobile>
    </Responsive>
  );
}

export default React.memo(FilterActions);
